import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  type: null,   // "view" | "edit" | "create"
  title:"",
  data: null,   // selected item
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      state.isOpen = true;
      state.type = action.payload.type;
       state.title = action.payload.title;
      state.data = action.payload.data;
    },

    closeModal: (state) => {
      state.isOpen = false;
      state.type = null;
      state.title = "";
      state.data = null;
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;
export default modalSlice.reducer;